<template>
    <div class="footer-brand-strip">
        <div class="container">
            <div class="footer-brand-inner">
                <router-link to="/anasayfa" class="footer-brand-logo">
                    <img src="/img/logo.jpg" alt="Ankara Ağrılılar Derneği Logosu">
                </router-link>
                <div class="footer-brand-copy">
                    <h2>Ankara Ağrılılar Derneği</h2>
                    <p>Başkent Ağrılılar Eğitim Kültür Sosyal Yardımlaşma ve Dayanışma Derneği. Kütük no: 06-158-130.</p>
                </div>
                <div class="footer-brand-actions">
                    <a href="tel:+905079217404" class="btn btn-dark">
                        <i class="fa fa-phone-alt me-2"></i>Ara
                    </a>
                    <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-primary">
                        <i class="fab fa-whatsapp me-2"></i>WhatsApp
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-dark text-light footer wow fadeIn" data-wow-delay="0.1s">
        <div class="container pb-5">
            <div class="row g-5">
                <div class="col-md-6 col-lg-4">
                    <div class="bg-primary rounded p-4">
                        <a href="index.html">
                            <h1 class="text-white text-uppercase mb-3">Ankara Ağrılılar Derneği</h1>
                        </a>
                        <p class="text-white mb-0">
                            Resmi adımız Başkent Ağrılılar Eğitim Kültür Sosyal Yardımlaşma ve Dayanışma Derneği'dir.
                            Ankara'daki Ağrılıları ortak dayanışma çatısında buluşturuyoruz.
                        </p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <h6 class="section-title text-start text-primary text-uppercase mb-4">İletişim</h6>
                    <p class="mb-2"><i class="fa fa-map-marker-alt me-3"></i>Dernek Binası, Mustafa Kemal, Ziya Gökalp Cd., 06946 Sincan/Ankara</p>
                    <a href="tel:+905079217404" class="footer-call-btn mb-2">
                        <i class="fa fa-phone-alt me-2"></i>+90 507 921 74 04
                    </a>
                    <p class="mb-2"><i class="fa fa-id-card me-3"></i>Kütük no: 06-158-130</p>
                    <div class="footer-social-links mb-3">
                        <a href="https://www.facebook.com/baskentagrililardernegi" target="_blank" rel="noopener" aria-label="Facebook">
                            <i class="fab fa-facebook-f"></i>
                        </a>
                        <a href="https://www.instagram.com/ankara_agrililar_dernegi/" target="_blank" rel="noopener" aria-label="Instagram">
                            <i class="fab fa-instagram"></i>
                        </a>
                    </div>
                    <div class="footer-action-grid mt-3">
                        <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-primary">
                            WhatsApp'a Katıl
                        </a>
                        <a :href="mapsUrl" target="_blank" rel="noopener" class="btn btn-outline-light">
                            Konumu Aç
                        </a>
                    </div>
                </div>
                <div class="col-lg-5 col-md-12">
                    <div class="row gy-5 g-4">
                        <div class="col-md-6">
                            <h6 class="section-title text-start text-primary text-uppercase mb-4">Dernek
                            </h6>

                            <router-link class="btn btn-link" to="/anasayfa">Anasayfa</router-link>
                            <router-link class="btn btn-link" to="/firmalar">Firmalarımız</router-link>
                            <router-link class="btn btn-link" to="/hakkimizda">Hakkımızda</router-link>
                            <router-link class="btn btn-link" to="/etkinlikler">Etkinliklerimiz</router-link>
                            <router-link class="btn btn-link" to="/haberler">Haberler</router-link>
                            <router-link class="btn btn-link" to="/iletisim">İletişim</router-link>
                            <router-link class="btn btn-link" to="/sss">Bilgi</router-link>
                        </div>
                        <div class="col-md-6">
                            <h6 class="section-title text-start text-primary text-uppercase mb-4">
                                Faaliyetlerimiz
                            </h6>
                            
                            <router-link class="btn btn-link" to="/firmalar">Firma Tanıtım</router-link>
                            <router-link class="btn btn-link" to="/hizmetlerimiz">Hizmetlerimiz</router-link>
                            <router-link class="btn btn-link" to="/kurucular">Kurucular</router-link>
                            <router-link class="btn btn-link" to="/kurullar">Kurullar</router-link>
                            <router-link class="btn btn-link" to="/tools">Araçlar</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="copyright">
                <div class="row">
                    <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                        &copy; <a class="border-bottom" href="#">Ankara Ağrılılar Derneği</a>, Tüm hakları saklıdır.
                    </div>
                    <div class="col-md-6 text-center text-md-end">
                        <div class="footer-menu">
                            <router-link to="/anasayfa">Anasayfa</router-link>
                            <router-link to="/firmalar">Firmalarımız</router-link>
                            <router-link to="/hakkimizda">Hakkımızda</router-link>
                            <router-link to="/etkinlikler">Etkinliklerimiz</router-link>
                            <router-link to="/haberler">Haberler</router-link>
                            <router-link to="/hizmetlerimiz">Hizmetlerimiz</router-link>
                            <router-link to="/kurucular">Kurucular</router-link>
                            <router-link to="/kurullar">Kurullar</router-link>
                            <router-link to="/iletisim">İletişim</router-link>
                            <router-link to="/sss">Bilgi</router-link>
                            <router-link to="/tools">Araçlar</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterBar',
    props: {
        msg: String
    },
    data() {
        return {
            whatsappJoinUrl: `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden katıldım, herkese merhabalar.')}`,
            mapsUrl: 'https://www.google.com/maps/place//data=!4m2!3m1!1s0x14d32f0045182ff9:0x7675f5df2b90b8b?sa=X&ved=1t:8290&ictx=111'
        }
    }
}
</script>
